/* global console, document, Excel, Office */

// The initialize function must be run each time a new page is loaded
Office.onReady(() => {
  let typingTimer;               
  let typeInterval = 100;  
  let searchInput = document.getElementById('searchbox');
  searchInput.addEventListener('keyup', () => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(liveSearch, typeInterval);
  });
});

function liveSearch() {
  let search_query = document.getElementById("searchbox").value;
  let cards = document.querySelectorAll('.data-box')
  for (var i = 0; i < cards.length; i++) {
    if(cards[i].textContent.toLowerCase().includes(search_query.toLowerCase())) {
      cards[i].classList.remove("is-hidden");
    } else {
      cards[i].classList.add("is-hidden");
    }
  }
}